import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './InfoPlate.css';

export interface IInfoPlateProps {
  content: React.ReactNode;
  icon: React.ReactNode;
  'data-testid'?: string;
  withHorizontalMargin?: boolean;
  onClick?: () => void;
}

export const InfoPlate: React.FC<IInfoPlateProps> = ({ content, icon, withHorizontalMargin, onClick, ...props }) => {
  const containerClassName = clsx(
    styles['container'],
    withHorizontalMargin && styles['horizontal-margin'],
    onClick && styles['clickable'],
  );

  return (
    <div className={containerClassName} data-testid={props['data-testid']} onClick={() => onClick?.()} role="button">
      <div className={styles['icon-wrapper']}>{icon}</div>
      {content}
    </div>
  );
};
